<template>
  <div class="simple-filter-and-block">
    <div class="block">

      <div class="blockTop">

        <select :value="expression.type" @change="setType">
          <option v-for="operator in possibleOperators" v-bind:value="operator.name">{{ operator.title }}</option>
        </select>

        <button v-if="parent" class="mdl-button delete-button" v-on:click="deleteThis">
          <i class="material-icons">delete_forever</i> Delete
        </button>

      </div>

      <div class="arg" v-for="(arg, argId) in expression.args">

        <div class="andLine" v-if="argId > 0">AND<div class="line"></div></div>
        <FilterExpression :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                           :parent="definition" @delete="deleteArg(argId)" @addAnd="addArg(argId)"></FilterExpression>

<!--        <button class="mdl-button add-button" v-if="definition.isList" v-on:click="addArg(argId)">
          <i class="material-icons">add</i> AND
        </button>-->
      </div>

    </div>
  </div>
</template>

<script>
import expression from "../../logic/expression.js"
import SimpleFilterOrBlock from "./SimpleFilterOrBlock"

export default {
  name: 'simple-filter-and-block',
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    expression: {
      type: Object,
      default: function() {
        return {
          type: "and",
          args: []
        }
      }
    },
    parent: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  components: {
    FilterExpression: SimpleFilterOrBlock
  },
  data () {
    return {
      possibleOperators: [
        { name: 'and', title: 'include' },
        { name: 'nand', title: 'exclude' }
      ]
    }
  },
  computed: {
    definition() {
      return expression.operatorsByName.get(this.expression.type)
    }
  },
  watch: {
  },
  methods: {
    operatorTitle(name) {
      for(let op of this.possibleOperators) {
        if(op.name == name) return op.title
      }
    },
    operatorDefinition(expr) {
      const operator = expression.operatorsByName.get(expr.type)
      console.log("OP", operator)
      return operator
    },
    addArg(at) {
      var nArg = {
        "type": "or",
        args: [
          {
            "type": ">",
            "args": ["Count", 100]
          }
        ]
      }
      var nArgs = this.expression.args.slice()
      nArgs.splice(at + 1, 0, nArg)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    setArg(argId, ev) {
      console.log("SET ARG", argId, ev)
      const nArgs = this.expression.args.slice()
      nArgs[argId] = ev
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteArg(argId) {
      console.log("DELETE ARG", argId)
      const nArgs = this.expression.args.slice()
      nArgs.splice(argId, 1)
      if(nArgs.length == 0) return this.deleteThis()
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    setType(ev) {
      let nType = ev.target.value
      var nDefinition = expression.operatorsByName.get(nType)
      console.log("SET TYPE", nType)
      if(!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse(JSON.stringify(this.expression))]
        })
      } else if(this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        })
      }/* else if ((this.definition.element != nDefinition.element)
        || (this.definition.left != nDefinition.left)
        || (this.definition.right != nDefinition.right)) {
        console.log("RESET ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: nDefinition.defaultArgs(this.columns)
        })
      }*/ else {
        console.log("HOLD ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: this.expression.args
        })
      }
    },
    deleteThis() {
      this.$emit('delete')
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .block {
    border-bottom: 1px solid rgba(0,0,0,0.4);
  }

  .block > .blockTop {
    margin-bottom: 2px;
  }

  .block button {
    display: block;
    font-size: 0.77em;
    height: 2em;
    line-height: 2em
  }

  .block button i {
    font-size: 1.23em;
    line-height: 0.77em;
  }
  .block .delete-button {
    display: inline-block;
    font-size: 0.77em;
    line-height: 1em;
    position: relative;
    top: -2px;
    float: right;
  }

  .andLine {
    font-size: 0.9em;
    position: relative;
    margin-left: 1em;
    font-weight: 700;
  }

  .andLine .line {
    position: absolute;
    background: #949494;
    right: 1em;
    left: 4em;
    top: 50%;
    height: 2px;
  }

</style>



// WEBPACK FOOTER //
// SimpleFilterAndBlock.vue?4318a170